import { type FC, type ReactNode } from 'react';
import classnames from 'classnames';

import dibsCss from 'dibs-css';

export const UrgencyBanner: FC<{
    backgroundColor: string;
    children: ReactNode;
}> = ({ backgroundColor, children }) => (
    <div
        // TODO: remove negative margin if test wins and handle it in title spacing
        style={{ marginTop: '-5px' }}
        className={classnames(
            dibsCss.wFull,
            dibsCss.flex,
            dibsCss.itemsCenter,
            dibsCss.pxSmall,
            dibsCss.pyXsmall,
            dibsCss.roundedXxsmall,
            dibsCss.textBodySmallNormal,
            dibsCss.mbSmaller,
            backgroundColor
        )}
    >
        {children}
    </div>
);
